export default {"src":"/_next/static/media/sports_football.92cb7775.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};